const LOGIN_URL = 'https://uat.definiteassurance.com/api/v1/login';
const SESSION_FLAG = 'da_docs_authenticated';
const SESSION_USER = 'da_docs_user';

// Calls the Definite Assurance login API with the credentials the user
// typed in. Credentials are never stored — only a boolean session flag
// and the username are kept, and only for this browser tab's session.
export async function login(username, password) {
  const url = `${LOGIN_URL}?username=${encodeURIComponent(username)}&password=${encodeURIComponent(
    password
  )}`;

  let res;
  try {
    res = await fetch(url, { method: 'GET' });
  } catch {
    throw new Error(
      'Could not reach the authentication server. Check your network connection and try again.'
    );
  }

  let data = null;
  try {
    data = await res.json();
  } catch {
    // Non-JSON response body is tolerated as long as the HTTP status is OK.
  }

  if (!res.ok || (data && data.success === false)) {
    throw new Error((data && (data.message || data.error)) || 'Invalid username or password.');
  }

  return data;
}

export function isAuthenticated() {
  return sessionStorage.getItem(SESSION_FLAG) === 'true';
}

export function setAuthenticated(username) {
  sessionStorage.setItem(SESSION_FLAG, 'true');
  if (username) sessionStorage.setItem(SESSION_USER, username);
}

export function getStoredUsername() {
  return sessionStorage.getItem(SESSION_USER) || '';
}

export function logout() {
  sessionStorage.removeItem(SESSION_FLAG);
  sessionStorage.removeItem(SESSION_USER);
}
